import dayjs from 'dayjs'
import ContentGuide from 'global/guides/ContentGuide'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import { useRelatorioDescontoDsrOutletContext } from './RelatorioDescontoDSRCliente'

export default function DetalhesDescontoDSR() {
    const { data } = useRelatorioDescontoDsrOutletContext()
    const { id } = useParams()

    const row = data?.find(item => item.id == id)
    const rows = row?.detalhes?.map((item, id) => ({ ...item, id }))
    return (
        <Dialog.Root>
            <Dialog.Title>{row?.Funcionario?.nome}</Dialog.Title>
            <Dialog.Content>
                <ContentGuide.DataGrid
                    loading={false}
                    columns={[
                        {
                            field: 'data',
                            headerName: 'Data',
                            type: 'date',
                            valueFormatter: ({ value }) =>
                                dayjs.utc(value).format('DD/MM/YYYY'),
                            flex: 1,
                        },
                        {
                            field: 'valor',
                            headerName: 'Valor descontado',
                            flex: 1,
                        },
                    ]}
                    rows={rows}
                    ToolbarProps={{ hideToolbar: true }}
                    hideFooter
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
